import LiveEvent from "../../components/live/live";
import Modal from "../../components/modal/modal";

/**
 *
 *  Локальные модалочки
 *
 */

new LiveEvent('click', '[data-modal]', function openModal(e) {
  e.preventDefault();
  let link = this;
  const theme = link.dataset.theme ? link.dataset.theme : 'default';
  let modal = new Modal(this, {
    animation: {
      classIn: '_open',
      classOut: '_close',
      timeoutIn: 16,
      timeoutOut: 16,
      closeTimeout: 700,
    },
    closerText: '',
    theme,
    onAfterOpen: function () {
      document.dispatchEvent(new Event('modal:open'));
    },
    onBeforeClose: function () {
    },
    onFormSuccess: function () {
      const submitEvent = new Event('modal-form:success');
      submitEvent.element = link;
      document.dispatchEvent(submitEvent);
    },
  });
  return false;
});